import React, { useState } from "react";
import axios from "axios";

function App() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(
        "/api/login",
        { username, password },
        { withCredentials: true }
      );

      if (res.data.success && res.data.targetUrl) {
        window.location.href = res.data.targetUrl;
      } else {
        setError("Giriş başarısız.");
      }
    } catch (err) {
      const msg =
        err.response?.data?.message || err.message || "Sunucu hatası";
      setError("Giriş başarısız: " + msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0f1117",
        fontFamily: "'Open Sans', 'Roboto', sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1.5rem",
        }}
      >
        {/* Logo - arka plan beyaz */}
        <div
          style={{
            width: "140px",
            height: "140px",
            background: "#fff",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
          }}
        >
          <img
            src="/logo_adamap.png"
            alt="Adamaper Logo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>

        {/* Başlık */}
        <div style={{ textAlign: "center" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "1.7rem",
              fontWeight: 600,
              color: "#e5e7eb",
            }}
          >
            Adamaper
          </h1>
          <div
            style={{
              marginTop: "0.25rem",
              fontSize: "0.9rem",
              color: "#9ca3af",
              fontStyle: "italic",
              fontWeight: 300,
            }}
          >
            “Dijital İkiz”
          </div>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          style={{
            width: "100%",
            background: "#1d1f27",
            padding: "1.75rem 1.5rem",
            borderRadius: "12px",
            border: "1px solid #2c2f38",
            boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
          }}
        >
          <label
            style={{
              display: "block",
              color: "#d1d5db",
              fontSize: "0.85rem",
              marginBottom: "0.3rem",
            }}
          >
            Kullanıcı Adı
          </label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{
              width: "100%",
              padding: "0.55rem 0.75rem",
              borderRadius: "8px",
              border: "1px solid #4b5563",
              background: "#0f1117",
              color: "#e5e7eb",
              marginBottom: "1rem",
              fontSize: "0.9rem",
            }}
          />

          <label
            style={{
              display: "block",
              color: "#d1d5db",
              fontSize: "0.85rem",
              marginBottom: "0.3rem",
            }}
          >
            Şifre
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "0.55rem 0.75rem",
              borderRadius: "8px",
              border: "1px solid #4b5563",
              background: "#0f1117",
              color: "#e5e7eb",
              marginBottom: "1rem",
              fontSize: "0.9rem",
            }}
          />

          {error && (
            <div
              style={{
                color: "#ff7043",
                fontSize: "0.85rem",
                marginBottom: "1rem",
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "0.65rem",
              borderRadius: "8px",
              border: "none",
              background: loading ? "#81c784" : "#4caf50",
              color: "#001e0c",
              fontWeight: 600,
              fontSize: "0.95rem",
              cursor: "pointer",
              transition: "0.15s",
            }}
          >
            {loading ? "Giriş Yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default App;